import { FormattedMessage } from 'react-intl';

import { Button } from '@sorare/core/src/atoms/buttons/Button';
import { glossary } from '@sorare/core/src/lib/glossary';

type Props = {
  onNext?: () => void;
  onClose: () => void;
};
export const Cta = ({ onNext, onClose }: Props) => {
  return onNext ? (
    <Button size="medium" color="secondary" fullWidth onClick={onNext}>
      <FormattedMessage {...glossary.next} />
    </Button>
  ) : (
    <Button size="medium" color="secondary" fullWidth onClick={onClose}>
      <FormattedMessage {...glossary.close} />
    </Button>
  );
};
